import React, { Component } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Button,
} from "reactstrap";
import { ColorButtonPicker } from "../../../../../components/ColorButtonPicker";

class EditChannel extends Component {
  state = {
    ChannelName: "",
    ToChannelName: "",
    ColorHex: "#4A4A4A",
    showColorPicker: false,
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleChangeColor = (color) => this.setState({ ColorHex: color.hex });

  toggleColorPicker = () =>
    this.setState({ showColorPicker: !this.state.showColorPicker });

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.initialValues !== this.props.initialValues) {
      const { initialValues } = nextProps;
      this.setState({
        ChannelName: initialValues.ChannelName,
        ToChannelName: initialValues.ToChannelName,
        ColorHex: initialValues.ColorHex,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isOpen !== this.props.isOpen) {
      let me = this;
      setTimeout(() => me.channelNameInput && me.channelNameInput.focus(), 700);
    }
  }

  render() {
    const { isOpen, toggleModal, modalHeader, handleSubmit } = this.props;
    const { showColorPicker, ...restValues } = this.state;

    return (
      <Modal isOpen={isOpen} style={{ minWidth: "550px" }}>
        <ModalHeader toggle={toggleModal}>{modalHeader}</ModalHeader>
        <ModalBody>
          <div
            style={{
              display: "grid",
              gridRowGap: "15px",
            }}
          >
            <div>
              <Label for="ChannelName">Channel name</Label>
              <input
                type="text"
                className="form-control"
                ref={(input) => {
                  this.channelNameInput = input;
                }}
                name="ChannelName"
                placeholder="Channel name"
                value={restValues.ChannelName}
                onChange={this.handleChange}
              />
            </div>
            <div>
              <Label for="ToChannelName">External name</Label>
              <input
                type="text"
                className="form-control"
                name="ToChannelName"
                placeholder="External name"
                value={restValues.ToChannelName}
                onChange={this.handleChange}
              />
            </div>
            <div>
              <Label style={{ margin: 0, float: "left" }} for="ColorHex">
                Color
              </Label>
              <div style={{ marginLeft: "1em", float: "left" }}>
                <ColorButtonPicker
                  handleChange={this.handleChangeColor}
                  togglePicker={this.toggleColorPicker}
                  showPicker={showColorPicker}
                  colorHex={restValues.ColorHex}
                />
              </div>
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <div>
              <Button
                color="primary"
                className="float-right"
                style={{ margin: 0 }}
                onClick={() => handleSubmit(restValues)}
              >
                Save
              </Button>
            </div>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

export { EditChannel };
